export enum Locale {
  DE_DE = 'de-DE',
  EN_US = 'en-US',
  ES_US = 'es-US',
  FR_FR = 'fr-FR',
  IT_IT = 'it-IT',
  JA_JP = 'ja-JP',
  KO_KR = 'ko-KR',
  PT_BR = 'pt-BR',
  ZH_CN = 'zh-CN',
  ZH_TW = 'zh-TW',
}

export const planYourVisitPathnames = {
  TOR_PLAN_YOUR_VISIT:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/',
  TOR_PLAN_YOUR_VISIT_TICKETS:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=tickets',
  TOR_PLAN_YOUR_VISIT_TICKETS_EXPRESS_PASS:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/express-pass/',
  TOR_PLAN_YOUR_VISIT_TICKETS_GENERAL_ADMISSION:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/general-admission/',
  TOR_PLAN_YOUR_VISIT_TICKETS_VIP_TOUR:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/vip-tour/',
  TOR_PLAN_YOUR_VISIT_TICKETS_CITYPASS:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/citypass/',
  TOR_PLAN_YOUR_VISIT_TICKETS_C3:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/c3/',
  TOR_PLAN_YOUR_VISIT_ACCESSIBILITY:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=accessibility',
  TOR_PLAN_YOUR_VISIT_DIRECTIONS:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=directions',
  TOR_PLAN_YOUR_VISIT_WHAT_TO_EXPECT:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=what-to-expect',
  TOR_PLAN_YOUR_VISIT_COMPARE_TICKETS:
    '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=compare-tickets',
};

export const ticketingPathnames = {
  BUY_TICKETS: '/buy-tickets/',
  CART: '/cart/',
  CHECKOUT: '/checkout/',
  CONFIRMATION: '/confirmation/',
  REFUNDS: '/buy-tickets/refunds/',
  GROUP_SALES: '/buy-tickets/group-sales/',
  CITYPASS_REDEMPTION: '/buy-tickets/citypass-redemption/',
  TOP_OF_THE_ROCK: '/buy-tickets/top-of-the-rock/',
  ALL_IN_PASS: '/buy-tickets/all-in-pass/',
  EXPRESS_PASS: '/buy-tickets/express-pass/',
  VIP: '/buy-tickets/vip/',
  ROCK_CENTER_TOUR: '/buy-tickets/rock-center-tour/',
  ROCK_PASS: '/buy-tickets/rock-pass/',
  VIP_ROCK_PASS: '/buy-tickets/vip-rock-pass/',
  THE_RINK: '/buy-tickets/the-rink/',
  THE_RINK_MEMBERSHIP: '/buy-tickets/the-rink-membership/',
  THE_RINK_VIP: '/buy-tickets/the-rink-vip/',
  KIDS_TOUR: '/buy-tickets/rockefeller-center-kids-tour/',
  THE_RINK_CHALETS: '/buy-tickets/the-rink-chalets/',
  CITYPASS: '/buy-tickets/citypass/',
  TREE_PHOTO: '/buy-tickets/tree-photo/',
  CHRISTMAS_TREE_PHOTO: '/buy-tickets/christmas-tree-photo/',
  VIP_ROCK_PASS_HOLIDAY: '/buy-tickets/vip-rock-pass-holiday-edition/',
  THE_BEAM_PASS: '/buy-tickets/the-beam-pass/',
  TICKETS: '/buy-tickets/tickets/',
};

export const holidayPathnames = {
  HOLIDAYS: '/holidays/',
  TREE_LIGHTING: '/holidays/rockefeller-center-christmas-tree-lighting/',
};

export const attractionPathnames = {
  THE_RINK: '/attractions/the-rink-at-rockefeller-center/',
  SKYLIFT: '/skylift/',
  THE_BEAM: '/the-beam/',
};

export const welcomePathnames = {
  WELCOME: '/welcome/',
};

export const cityPassUrls = {
  COMPARISON_C3:
    'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=buytickets-c3-lm',
  TICKETS_CP:
    'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp',
  HOME: 'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=hometor',
  PLAN_TICKETS:
    'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets',
  PLAN_COMPARE_CP:
    'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp',
  PLAN_COMPARE_C3:
    'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3',
};

export default {
  // Top of the Rock Observation Deck paths
  '/attractions/top-of-the-rock-observation-deck/': {
    [Locale.DE_DE]: '/attraktionen/top-of-the-rock-aussichtsplattform/',
    [Locale.EN_US]: '/attractions/top-of-the-rock-observation-deck/',
    [Locale.ES_US]: '/atracciones/mirador-top-of-the-rock/',
    [Locale.FR_FR]: '/attractions/plateforme-observation-top-of-the-rock/',
    [Locale.IT_IT]: '/attrazioni/terrazza_panoramica_top-of-the-rock/',
    [Locale.JA_JP]: '/アトラクション/トップ・オブ・ザ・ロック展望台/',
    [Locale.KO_KR]: '/명소/탑-오브-더-락-전망대/',
    [Locale.PT_BR]: '/atrações/deque-de-observação-do-top-of-the-rock/',
    [Locale.ZH_CN]: '/景点/巨石之巅观景台/',
    [Locale.ZH_TW]: '/景點/巨石之巔觀景台/',
  },

  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/': {
    [Locale.DE_DE]:
      '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/',
    [Locale.EN_US]:
      '/attractions/top-of-the-rock-observation-deck/plan-your-visit/',
    [Locale.ES_US]:
      '/atracciones/mirador-top-of-the-rock/planifique-su-visita/',
    [Locale.FR_FR]:
      '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/',
    [Locale.IT_IT]:
      '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/',
    [Locale.JA_JP]:
      '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/',
    [Locale.KO_KR]: '/명소/탑-오브-더-락-전망대/방문-계획/',
    [Locale.PT_BR]:
      '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/',
    [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/',
    [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/',
  },
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=tickets':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=tickets',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=tickets',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=tickets',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/?tab=tickets',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/?tab=tickets',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/?tab=tickets',
      [Locale.KO_KR]: '/명소/탑-오브-더-락-전망대/방문-계획/?tab=tickets',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=tickets',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/?tab=tickets',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/?tab=tickets',
    },
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=tickets&tor=true':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=tickets&tor=true',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=tickets&tor=true',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=tickets&tor=true',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/?tab=tickets&tor=true',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/?tab=tickets&tor=true',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/?tab=tickets&tor=true',
      [Locale.KO_KR]:
        '/명소/탑-오브-더-락-전망대/방문-계획/?tab=tickets&tor=true',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=tickets&tor=true',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/?tab=tickets&tor=true',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/?tab=tickets&tor=true',
    },
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=compare-tickets':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=compare-tickets',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=compare-tickets',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=compare-tickets',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/?tab=compare-tickets',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/?tab=compare-tickets',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/?tab=compare-tickets',
      [Locale.KO_KR]:
        '/명소/탑-오브-더-락-전망대/방문-계획/?tab=compare-tickets',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=compare-tickets',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/?tab=compare-tickets',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/?tab=compare-tickets',
    },
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=what-to-expect':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=what-to-expect',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=what-to-expect',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=what-to-expect',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/?tab=what-to-expect',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/?tab=what-to-expect',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/?tab=what-to-expect',
      [Locale.KO_KR]:
        '/명소/탑-오브-더-락-전망대/방문-계획/?tab=what-to-expect',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=what-to-expect',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/?tab=what-to-expect',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/?tab=what-to-expect',
    },
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=accessibility':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=accessibility',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=accessibility',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=accessibility',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifiez-votre-visite/?tab=accessibility',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/pianifica-la-tua-visita/?tab=accessibility',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/訪問を計画する/?tab=accessibility',
      [Locale.KO_KR]: '/명소/탑-오브-더-락-전망대/방문-계획/?tab=accessibility',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=accessibility',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/规划行程/?tab=accessibility',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃行程/?tab=accessibility',
    },

  // Cart and Checkout paths
  '/cart/': {
    [Locale.DE_DE]: '/warenkorb/',
    [Locale.EN_US]: '/cart/',
    [Locale.ES_US]: '/carrito/',
    [Locale.FR_FR]: '/panier/',
    [Locale.IT_IT]: '/carrello/',
    [Locale.JA_JP]: '/カート/',
    [Locale.KO_KR]: '/장바구니/',
    [Locale.PT_BR]: '/carrinho/',
    [Locale.ZH_CN]: '/购物车/',
    [Locale.ZH_TW]: '/購物車/',
  },
  '/checkout/': {
    [Locale.DE_DE]: '/kasse/',
    [Locale.EN_US]: '/checkout/',
    [Locale.ES_US]: '/pago/',
    [Locale.FR_FR]: '/paiement/',
    [Locale.IT_IT]: '/checkout/',
    [Locale.JA_JP]: '/チェックアウト/',
    [Locale.KO_KR]: '/결제/',
    [Locale.PT_BR]: '/checkout/',
    [Locale.ZH_CN]: '/结账/',
    [Locale.ZH_TW]: '/結帳/',
  },
  '/confirmation/': {
    [Locale.DE_DE]: '/bestätigung/',
    [Locale.EN_US]: '/confirmation/',
    [Locale.ES_US]: '/confirmación/',
    [Locale.FR_FR]: '/confirmation/',
    [Locale.IT_IT]: '/conferma/',
    [Locale.JA_JP]: '/確認/',
    [Locale.KO_KR]: '/확인/',
    [Locale.PT_BR]: '/confirmação/',
    [Locale.ZH_CN]: '/确认/',
    [Locale.ZH_TW]: '/確認/',
  },

  // Buy tickets paths
  '/buy-tickets/': {
    [Locale.DE_DE]: '/tickets-kaufen/',
    [Locale.EN_US]: '/buy-tickets/',
    [Locale.ES_US]: '/comprar-boletos/',
    [Locale.FR_FR]: '/acheter-des-billets/',
    [Locale.IT_IT]: '/comprare-biglietti/',
    [Locale.JA_JP]: '/チケットを買う/',
    [Locale.KO_KR]: '/티켓-구매하기/',
    [Locale.PT_BR]: '/comprar-ingressos/',
    [Locale.ZH_CN]: '/买票/',
    [Locale.ZH_TW]: '/買票/',
  },

  // Holiday and seasonal paths
  '/holidays/': {
    [Locale.DE_DE]: '/feiertage/',
    [Locale.EN_US]: '/holidays/',
    [Locale.ES_US]: '/festividades/',
    [Locale.FR_FR]: '/fetes/',
    [Locale.IT_IT]: '/festivita/',
    [Locale.JA_JP]: '/ホリデー/',
    [Locale.KO_KR]: '/휴일/',
    [Locale.PT_BR]: '/feriados/',
    [Locale.ZH_CN]: '/节日/',
    [Locale.ZH_TW]: '/節日/',
  },
  '/holidays/rockefeller-center-christmas-tree-lighting/': {
    [Locale.DE_DE]: '/feiertage/rockefeller-center-weihnachtsbaum-beleuchtung/',
    [Locale.EN_US]: '/holidays/rockefeller-center-christmas-tree-lighting/',
    [Locale.ES_US]:
      '/festividades/iluminacion-arbol-navidad-rockefeller-center/',
    [Locale.FR_FR]: '/fetes/illumination-sapin-noel-rockefeller-center/',
    [Locale.IT_IT]: '/festivita/accensione-albero-natale-rockefeller-center/',
    [Locale.JA_JP]: '/ホリデー/ロックフェラーセンター・クリスマスツリー点灯式/',
    [Locale.KO_KR]: '/휴일/록펠러-센터-크리스마스-트리-점등식/',
    [Locale.PT_BR]: '/feriados/iluminacao-arvore-natal-rockefeller-center/',
    [Locale.ZH_CN]: '/节日/洛克菲勒中心圣诞树亮灯仪式/',
    [Locale.ZH_TW]: '/節日/洛克菲勒中心聖誕樹亮燈儀式/',
  },

  // Attraction-specific paths
  '/attractions/the-rink-at-rockefeller-center/': {
    [Locale.DE_DE]: '/attraktionen/die-eisbahn-am-rockefeller-center/',
    [Locale.EN_US]: '/attractions/the-rink-at-rockefeller-center/',
    [Locale.ES_US]: '/atracciones/la-pista-de-patinaje-en-rockefeller-center/',
    [Locale.FR_FR]: '/attractions/la-patinoire-du-rockefeller-center/',
    [Locale.IT_IT]:
      '/attrazioni/la-pista-di-pattinaggio-al-rockefeller-center/',
    [Locale.JA_JP]: '/アトラクション/ロックフェラーセンター・アイスリンク/',
    [Locale.KO_KR]: '/명소/록펠러-센터-스케이트장/',
    [Locale.PT_BR]: '/atrações/pista-de-patinacao-do-rockefeller-center/',
    [Locale.ZH_CN]: '/景点/洛克菲勒中心溜冰场/',
    [Locale.ZH_TW]: '/景點/洛克菲勒中心溜冰場/',
  },
  '/skylift/': {
    [Locale.DE_DE]: '/skylift/',
    [Locale.EN_US]: '/skylift/',
    [Locale.ES_US]: '/skylift/',
    [Locale.FR_FR]: '/skylift/',
    [Locale.IT_IT]: '/skylift/',
    [Locale.JA_JP]: '/skylift/',
    [Locale.KO_KR]: '/skylift/',
    [Locale.PT_BR]: '/skylift/',
    [Locale.ZH_CN]: '/skylift/',
    [Locale.ZH_TW]: '/skylift/',
  },
  '/the-beam/': {
    [Locale.DE_DE]: '/the-beam/',
    [Locale.EN_US]: '/the-beam/',
    [Locale.ES_US]: '/the-beam/',
    [Locale.FR_FR]: '/the-beam/',
    [Locale.IT_IT]: '/the-beam/',
    [Locale.JA_JP]: '/the-beam/',
    [Locale.KO_KR]: '/the-beam/',
    [Locale.PT_BR]: '/the-beam/',
    [Locale.ZH_CN]: '/the-beam/',
    [Locale.ZH_TW]: '/the-beam/',
  },

  // Welcome paths
  '/welcome/': {
    [Locale.DE_DE]: '/willkommen/',
    [Locale.EN_US]: '/welcome/',
    [Locale.ES_US]: '/bienvenidos/',
    [Locale.FR_FR]: '/bienvenue/',
    [Locale.IT_IT]: '/benvenuti/',
    [Locale.JA_JP]: '/ようこそ/',
    [Locale.KO_KR]: '/환영합니다/',
    [Locale.PT_BR]: '/bem-vindo/',
    [Locale.ZH_CN]: '/欢迎/',
    [Locale.ZH_TW]: '/歡迎/',
  },

  // Beam Safety Guidelines
  '/beam-safety-guidelines/': {
    [Locale.DE_DE]: '/strahlenschutz-richtlinien/',
    [Locale.EN_US]: '/beam-safety-guidelines/',
    [Locale.ES_US]: '/directrices-de-seguridad-del-rayo/',
    [Locale.FR_FR]: '/consignes-de-securite-du-faisceau/',
    [Locale.IT_IT]: '/linee-guida-sicurezza-fascio/',
    [Locale.JA_JP]: '/ビーム安全ガイドライン/',
    [Locale.KO_KR]: '/빔-안전-지침/',
    [Locale.PT_BR]: '/diretrizes-de-seguranca-do-feixe/',
    [Locale.ZH_CN]: '/光束安全指南/',
    [Locale.ZH_TW]: '/光束安全指引/',
  },

  // Plan your visit paths
  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/citypass/':
    {
      [Locale.DE_DE]:
        '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/tickets/citypass/',
      [Locale.EN_US]:
        '/attractions/top-of-the-rock-observation-deck/plan-your-visit/tickets/citypass/',
      [Locale.ES_US]:
        '/atracciones/mirador-top-of-the-rock/planifique-su-visita/boletos/citypass/',
      [Locale.FR_FR]:
        '/attractions/plateforme-observation-top-of-the-rock/planifier-votre-visite/billets/citypass',
      [Locale.IT_IT]:
        '/attrazioni/terrazza_panoramica_top-of-the-rock/programma-la-tua-visita/biglietti/citypass/',
      [Locale.JA_JP]:
        '/アトラクション/トップ・オブ・ザ・ロック展望台/ご案内/各種チケット/シティパス/',
      [Locale.KO_KR]:
        '/명소/탑-오브-더-락-전망대/여행-계획을-세우세요/티켓/citypass/',
      [Locale.PT_BR]:
        '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/ingressos/citypass/',
      [Locale.ZH_CN]: '/景点/巨石之巅观景台/计划您的旅行/门票/citypass/',
      [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃您的旅行/門票/citypass/',
    },

  '/attractions/top-of-the-rock-observation-deck/plan-your-visit/directions/': {
    [Locale.DE_DE]:
      '/attraktionen/top-of-the-rock-aussichtsplattform/planen-sie-ihren-besuch/?tab=wegbeschreibung',
    [Locale.EN_US]:
      '/attractions/top-of-the-rock-observation-deck/plan-your-visit/?tab=directions',
    [Locale.ES_US]:
      '/atracciones/mirador-top-of-the-rock/planifique-su-visita/?tab=indicaciones-para-llegar',
    [Locale.FR_FR]:
      '/attractions/plateforme-observation-top-of-the-rock/planifier-votre-visite/?tab=itineraires',
    [Locale.IT_IT]:
      '/attrazioni/terrazza_panoramica_top-of-the-rock/programma-la-tua-visita/?tab=indicazioni',
    [Locale.JA_JP]:
      '/アトラクション/トップ・オブ・ザ・ロック展望台/ご案内/?tab=行き方',
    [Locale.KO_KR]:
      '/명소/탑-오브-더-락-전망대/여행-계획을-세우세요/?tab=오시는-길',
    [Locale.PT_BR]:
      '/atrações/deque-de-observação-do-top-of-the-rock/planeje-sua-visita/?tab=como-chegar',
    [Locale.ZH_CN]: '/景点/巨石之巅观景台/计划您的旅行/?tab=路线',
    [Locale.ZH_TW]: '/景點/巨石之巔觀景台/規劃您的旅行/?tab=路線',
  },

  // Buy tickets paths
  '/buy-tickets/top-of-the-rock/': {
    [Locale.DE_DE]: '/tickets-kaufen/top-of-the-rock/',
    [Locale.EN_US]: '/buy-tickets/top-of-the-rock/',
    [Locale.ES_US]: '/comprar-boletos/top-of-the-rock/',
    [Locale.FR_FR]: '/acheter-des-billets/top-of-the-rock/',
    [Locale.IT_IT]: '/comprare-biglietti/top-of-the-rock/',
    [Locale.JA_JP]: '/チケットを買う/top-of-the-rock/',
    [Locale.KO_KR]: '/티켓-구매하기/top-of-the-rock/',
    [Locale.PT_BR]: '/comprar-ingressos/top-of-the-rock/',
    [Locale.ZH_CN]: '/买票/top-of-the-rock/',
    [Locale.ZH_TW]: '/買票/top-of-the-rock/',
  },
  '/buy-tickets/all-in-pass/': {
    [Locale.DE_DE]: '/tickets-kaufen/all-in-pass/',
    [Locale.EN_US]: '/buy-tickets/all-in-pass/',
    [Locale.ES_US]: '/comprar-boletos/all-in-pass/',
    [Locale.FR_FR]: '/acheter-des-billets/all-in-pass/',
    [Locale.IT_IT]: '/comprare-biglietti/all-in-pass/',
    [Locale.JA_JP]: '/チケットを買う/all-in-pass/',
    [Locale.KO_KR]: '/티켓-구매하기/all-in-pass/',
    [Locale.PT_BR]: '/comprar-ingressos/all-in-pass/',
    [Locale.ZH_CN]: '/买票/all-in-pass/',
    [Locale.ZH_TW]: '/買票/all-in-pass/',
  },
  '/buy-tickets/express-pass/': {
    [Locale.DE_DE]: '/tickets-kaufen/express-pass/',
    [Locale.EN_US]: '/buy-tickets/express-pass/',
    [Locale.ES_US]: '/comprar-boletos/express-pass/',
    [Locale.FR_FR]: '/acheter-des-billets/express-pass/',
    [Locale.IT_IT]: '/comprare-biglietti/express-pass/',
    [Locale.JA_JP]: '/チケットを買う/express-pass/',
    [Locale.KO_KR]: '/티켓-구매하기/express-pass/',
    [Locale.PT_BR]: '/comprar-ingressos/express-pass/',
    [Locale.ZH_CN]: '/买票/express-pass/',
    [Locale.ZH_TW]: '/買票/express-pass/',
  },
  '/buy-tickets/vip/': {
    [Locale.DE_DE]: '/tickets-kaufen/vip/',
    [Locale.EN_US]: '/buy-tickets/vip/',
    [Locale.ES_US]: '/comprar-boletos/vip/',
    [Locale.FR_FR]: '/acheter-des-billets/vip/',
    [Locale.IT_IT]: '/comprare-biglietti/vip/',
    [Locale.JA_JP]: '/チケットを買う/vip/',
    [Locale.KO_KR]: '/티켓-구매하기/vip/',
    [Locale.PT_BR]: '/comprar-ingressos/vip/',
    [Locale.ZH_CN]: '/买票/vip/',
    [Locale.ZH_TW]: '/買票/vip/',
  },
  '/buy-tickets/rock-center-tour/': {
    [Locale.DE_DE]: '/tickets-kaufen/rock-center-tour/',
    [Locale.EN_US]: '/buy-tickets/rock-center-tour/',
    [Locale.ES_US]: '/comprar-boletos/rock-center-tour/',
    [Locale.FR_FR]: '/acheter-des-billets/rock-center-tour/',
    [Locale.IT_IT]: '/comprare-biglietti/rock-center-tour/',
    [Locale.JA_JP]: '/チケットを買う/rock-center-tour/',
    [Locale.KO_KR]: '/티켓-구매하기/rock-center-tour/',
    [Locale.PT_BR]: '/comprar-ingressos/rock-center-tour/',
    [Locale.ZH_CN]: '/买票/rock-center-tour/',
    [Locale.ZH_TW]: '/買票/rock-center-tour/',
  },
  '/buy-tickets/rock-pass/': {
    [Locale.DE_DE]: '/tickets-kaufen/rock-pass/',
    [Locale.EN_US]: '/buy-tickets/rock-pass/',
    [Locale.ES_US]: '/comprar-boletos/rock-pass/',
    [Locale.FR_FR]: '/acheter-des-billets/rock-pass/',
    [Locale.IT_IT]: '/comprare-biglietti/rock-pass/',
    [Locale.JA_JP]: '/チケットを買う/rock-pass/',
    [Locale.KO_KR]: '/티켓-구매하기/rock-pass/',
    [Locale.PT_BR]: '/comprar-ingressos/rock-pass/',
    [Locale.ZH_CN]: '/买票/rock-pass/',
    [Locale.ZH_TW]: '/買票/rock-pass/',
  },
  '/buy-tickets/vip-rock-pass/': {
    [Locale.DE_DE]: '/tickets-kaufen/vip-rock-pass/',
    [Locale.EN_US]: '/buy-tickets/vip-rock-pass/',
    [Locale.ES_US]: '/comprar-boletos/vip-rock-pass/',
    [Locale.FR_FR]: '/acheter-des-billets/rock-pass-vip/',
    [Locale.IT_IT]: '/comprare-biglietti/rock-pass-vip/',
    [Locale.JA_JP]: '/チケットを買う/vip-rock-pass/',
    [Locale.KO_KR]: '/티켓-구매하기/vip-rock-pass/',
    [Locale.PT_BR]: '/comprar-ingressos/rock-pass-vip/',
    [Locale.ZH_CN]: '/买票/vip-rock-pass/',
    [Locale.ZH_TW]: '/買票/vip-rock-通行證/',
  },
  '/buy-tickets/the-rink/': {
    [Locale.DE_DE]: '/tickets-kaufen/the-rink/',
    [Locale.EN_US]: '/buy-tickets/the-rink/',
    [Locale.ES_US]: '/comprar-boletos/the-rink/',
    [Locale.FR_FR]: '/acheter-des-billets/the-rink/',
    [Locale.IT_IT]: '/comprare-biglietti/the-rink/',
    [Locale.JA_JP]: '/チケットを買う/the-rink/',
    [Locale.KO_KR]: '/티켓-구매하기/the-rink/',
    [Locale.PT_BR]: '/comprar-ingressos/the-rink/',
    [Locale.ZH_CN]: '/买票/the-rink/',
    [Locale.ZH_TW]: '/買票/the-rink/',
  },
  '/buy-tickets/the-rink-membership/': {
    [Locale.DE_DE]: '/tickets-kaufen/the-rink-membership/',
    [Locale.EN_US]: '/buy-tickets/the-rink-membership/',
    [Locale.ES_US]: '/comprar-boletos/the-rink-membership/',
    [Locale.FR_FR]: '/acheter-des-billets/the-rink-membership/',
    [Locale.IT_IT]: '/comprare-biglietti/the-rink-membership/',
    [Locale.JA_JP]: '/チケットを買う/the-rink-membership/',
    [Locale.KO_KR]: '/티켓-구매하기/the-rink-membership/',
    [Locale.PT_BR]: '/comprar-ingressos/the-rink-membership/',
    [Locale.ZH_CN]: '/买票/the-rink-membership/',
    [Locale.ZH_TW]: '/買票/the-rink-membership/',
  },
  '/buy-tickets/the-rink-vip/': {
    [Locale.DE_DE]: '/tickets-kaufen/the-rink-vip/',
    [Locale.EN_US]: '/buy-tickets/the-rink-vip/',
    [Locale.ES_US]: '/comprar-boletos/the-rink-vip/',
    [Locale.FR_FR]: '/acheter-des-billets/the-rink-vip/',
    [Locale.IT_IT]: '/comprare-biglietti/the-rink-vip/',
    [Locale.JA_JP]: '/チケットを買う/the-rink-vip/',
    [Locale.KO_KR]: '/티켓-구매하기/the-rink-vip/',
    [Locale.PT_BR]: '/comprar-ingressos/the-rink-vip/',
    [Locale.ZH_CN]: '/买票/the-rink-vip/',
    [Locale.ZH_TW]: '/買票/the-rink-vip/',
  },
  '/buy-tickets/rockefeller-center-kids-tour/': {
    [Locale.DE_DE]: '/tickets-kaufen/rockefeller-center-kinder-tour/',
    [Locale.EN_US]: '/buy-tickets/rockefeller-center-kids-tour/',
    [Locale.ES_US]: '/comprar-boletos/rockefeller-center-tour-ninos/',
    [Locale.FR_FR]: '/acheter-des-billets/rockefeller-center-visite-enfants/',
    [Locale.IT_IT]: '/comprare-biglietti/rockefeller-center-tour-bambini/',
    [Locale.JA_JP]: '/チケットを買う/rockefeller-center-キッズ-ツアー/',
    [Locale.KO_KR]: '/티켓-구매하기/rockefeller-center-어린이-투어/',
    [Locale.PT_BR]: '/comprar-ingressos/rockefeller-center-tour-infantil/',
    [Locale.ZH_CN]: '/买票/rockefeller-center-kids-tour-儿童之旅/',
    [Locale.ZH_TW]: '/買票/rockefeller-center-兒童-導覽/',
  },
  '/buy-tickets/the-rink-chalets/': {
    [Locale.DE_DE]: '/tickets-kaufen/the-rink-chalets/',
    [Locale.EN_US]: '/buy-tickets/the-rink-chalets/',
    [Locale.ES_US]: '/comprar-boletos/chalets-de-rink/',
    [Locale.FR_FR]: '/acheter-des-billets/chalets-de-rink/',
    [Locale.IT_IT]: '/comprare-biglietti/chalet-di-rink/',
    [Locale.JA_JP]: '/チケットを買う/ザ・リンク-シャレー/',
    [Locale.KO_KR]: '/티켓-구매하기/더-링크-샬레/',
    [Locale.PT_BR]: '/comprar-ingressos/chalés-de-rink/',
    [Locale.ZH_CN]: '/买票/the-rink-小屋/',
    [Locale.ZH_TW]: '/買票/the-rink-小木屋/',
  },
  '/buy-tickets/citypass/': {
    [Locale.DE_DE]: '/tickets-kaufen/citypass/',
    [Locale.EN_US]: '/buy-tickets/citypass/',
    [Locale.ES_US]: '/comprar-boletos/citypass/',
    [Locale.FR_FR]: '/acheter-des-billets/citypass/',
    [Locale.IT_IT]: '/comprare-biglietti/citypass/',
    [Locale.JA_JP]: '/チケットを買う/citypass/',
    [Locale.KO_KR]: '/티켓-구매하기/citypass/',
    [Locale.PT_BR]: '/comprar-ingressos/citypass/',
    [Locale.ZH_CN]: '/买票/citypass/',
    [Locale.ZH_TW]: '/買票/citypass/',
  },
  '/buy-tickets/citypass-redemption/': {
    [Locale.DE_DE]: '/tickets-kaufen/citypass-einloesen/',
    [Locale.EN_US]: '/buy-tickets/citypass-redemption/',
    [Locale.ES_US]: '/comprar-boletos/canje-citypass/',
    [Locale.FR_FR]: '/acheter-des-billets/échange-citypass/',
    [Locale.IT_IT]: '/comprare-biglietti/citypass-riscatto/',
    [Locale.JA_JP]: '/チケットを買う/citypass-引換/',
    [Locale.KO_KR]: '/티켓-구매하기/citypass-상환/',
    [Locale.PT_BR]: '/comprar-ingressos/resgate-citypass/',
    [Locale.ZH_CN]: '/买票/citypass-redemption/',
    [Locale.ZH_TW]: '/買票/citypass-兌換/',
  },
  '/buy-tickets/confirmation/': {
    [Locale.EN_US]: '/buy-tickets/confirmation/',
    [Locale.DE_DE]: '/tickets-kaufen/bestätigung/',
    [Locale.ES_US]: '/comprar-boletos/confirmación/',
    [Locale.FR_FR]: '/acheter-des-billets/confirmation/',
    [Locale.IT_IT]: '/comprare-biglietti/conferma/',
    [Locale.JA_JP]: '/チケットを買う/確認',
    [Locale.KO_KR]: '/티켓-구매하기/확인',
    [Locale.PT_BR]: '/comprar-ingressos/confirmação/',
    [Locale.ZH_CN]: '/买票/确认',
    [Locale.ZH_TW]: '/買票/確認',
  },
  '/buy-tickets/refunds/': {
    [Locale.EN_US]: '/buy-tickets/refunds/',
    [Locale.DE_DE]: '/tickets-kaufen/erstattungen/',
    [Locale.ES_US]: '/comprar-boletos/reembolsos/',
    [Locale.FR_FR]: '/acheter-des-billets/remboursements/',
    [Locale.IT_IT]: '/comprare-biglietti/rimborsi/',
    [Locale.JA_JP]: '/チケットを買う/返金/',
    [Locale.KO_KR]: '/티켓-구매하기/환불/',
    [Locale.PT_BR]: '/comprar-ingressos/reembolsos/',
    [Locale.ZH_CN]: '/买票/refunds/',
    [Locale.ZH_TW]: '/買票/退款/',
  },
  '/buy-tickets/group-sales/': {
    [Locale.DE_DE]: '/tickets-kaufen/gruppentickets/',
    [Locale.EN_US]: '/buy-tickets/group-sales/',
    [Locale.ES_US]: '/comprar-boletos/ventas-grupo/',
    [Locale.FR_FR]: '/acheter-des-billets/offres-groupes/',
    [Locale.IT_IT]: '/comprare-biglietti/vendite-di-gruppo/',
    [Locale.JA_JP]: '/チケットを買う/グループ-販売/',
    [Locale.KO_KR]: '/티켓-구매하기/단체-구매/',
    [Locale.PT_BR]: '/comprar-ingressos/vendas-grupos/',
    [Locale.ZH_CN]: '/买票/group-sales/',
    [Locale.ZH_TW]: '/買票/團體-銷售/',
  },

  // CityPass URLs
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-top-zh',
    },

  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=hometor': {
    [Locale.EN_US]:
      'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=hometor',
    [Locale.ES_US]:
      'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-es',
    [Locale.FR_FR]:
      'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-fr',
    [Locale.IT_IT]:
      'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-it',
    [Locale.DE_DE]:
      'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-de',
    [Locale.PT_BR]:
      'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-pt',
    [Locale.JA_JP]:
      'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-ja',
    [Locale.ZH_CN]:
      'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-zh',
    [Locale.KO_KR]:
      'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=hometor',
    [Locale.ZH_TW]:
      'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=hometor-zh',
  },
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=buytickets-passes-zh',
    },
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-cp-zh',
    },
  'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-tickets-c3-zh',
    },
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-tickets-passes-zh',
    },

  // not tested below
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-top-zh',
    },
  'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york?mv_source=topoftherock&campaign=plan-compare-cp-zh',
    },
  'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3':
    {
      [Locale.EN_US]:
        'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3',
      [Locale.ES_US]:
        'https://es.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-es',
      [Locale.FR_FR]:
        'https://fr.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-fr',
      [Locale.IT_IT]:
        'https://it.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-it',
      [Locale.DE_DE]:
        'https://de.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-de',
      [Locale.PT_BR]:
        'https://pt.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-pt',
      [Locale.JA_JP]:
        'https://ja.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-ja',
      [Locale.ZH_CN]:
        'https://zh.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-zh',
      [Locale.KO_KR]:
        'https://www.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3',
      [Locale.ZH_TW]:
        'https://zh.citypass.com/new-york-comparison?mv_source=topoftherock&campaign=plan-compare-c3-zh',
    },
} as Record<string, Record<Locale, string>>;
